import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { useAlert } from "../../../context/AlertContext";
import { Container, Tabs, Tab } from "react-bootstrap";
import PreviewEquipForm from "./Tabs/PreviewEquip";

export default function PreviewEquipment() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [selectedTab, setSelectedTab] = useState("");
  const Id = state?.Id || [];
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    handleChangeTab("CheckEquipment");
    setTimeout(() => setWebsiteName("ตรวจรับอุปกรณ์/อะไหล่"), 300);
  }, []);

  const handleChangeTab = (key) => {
    switch (key) {
      case "JobDetails":
        setWebsiteName("ข้อมูลการรับงาน");
        setSelectedTab("JobDetails");
        break;
      case "CheckEquipment":
        setWebsiteName("ตรวจรับอุปกรณ์/อะไหล่");
        setSelectedTab("CheckEquipment");
        break;
      case "CheckJobDetails":
        setWebsiteName("ตรวจสอบรายละเอียดงาน");
        setSelectedTab("CheckJobDetails");
        break;
      case "EventplaningCalendar":
        setWebsiteName("ปฏิทินงานช่าง");
        setSelectedTab("EventplaningCalendar");
        break;
      default:
        setWebsiteName("ทีมงานรับงาน");
        setSelectedTab("acceptance");
    }
  };

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Head Event Planning Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={"CheckEquipment"}
          onSelect={(k) => handleChangeTab(k)}
          className="mb-3"
        >
          <Tab eventKey="acceptance" title="ทีมงานรับงาน" disabled></Tab>
          <Tab eventKey="JobDetails" title="ข้อมูลการรับงาน" disabled></Tab>
          <Tab eventKey="CheckEquipment" title="ตรวจรับอุปกรณ์/อะไหล่" disabled>
             {<PreviewEquipForm Id={Id}/>}
          </Tab>
          <Tab eventKey="CheckJobDetails" title="ตรวจสอบรายละเอียดงาน" disabled></Tab>
          <Tab eventKey="EventplaningCalendar" title="ปฏิทินงานช่าง" disabled></Tab>
        </Tabs>
      </Container>
    </>
  );
}
